import { Action } from '@ngrx/store';
import { LotCapacity } from '@cemex-core/cmx-api/models/jobsite-std-lot/lot-capacity';
import { MinLotSizeRequest } from '@cemex-core/cmx-api/models/std-lot-size/min-std-lot-size-req';

export enum MinLotActionTypes {
  LOAD_MIN_LOT = '[MinLot] Load min lot',
  LOAD_MIN_LOT_SUCCESS = '[MinLot] Load min lot complete',
  RESET_MIN_LOT = '[MinLot] Reset',
}

export class LoadMinLot implements Action {
  readonly type = MinLotActionTypes.LOAD_MIN_LOT;

  constructor(public payload: { productId: number; request: MinLotSizeRequest }) {}
}

export class LoadMinLotComplete implements Action {
  readonly type = MinLotActionTypes.LOAD_MIN_LOT_SUCCESS;

  constructor(public payload: { [productId: number]: LotCapacity }) {}
}

export class ResetMinLot implements Action {
  readonly type = MinLotActionTypes.RESET_MIN_LOT;

  constructor() {}
}

export type MinLotActions = LoadMinLot | LoadMinLotComplete | ResetMinLot;
